export enum RouteAction {
    Editar = 'editar',
    Visualizar = 'visualizar',
    Inserir = 'inserir',
    InserirMultiplos = 'inserirMultiplos'
}

export enum LoginAction {
    TrocarSenha = 'trocarSenha',
    EsqueciMinhaSenha = "esqueciMinhaSenha"
}